/* eslint-disable */
import React, {memo, useEffect, useState} from "react";
import styles from "./VideoSuggestionsPanel.module.css";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../../../../root/RootReducer";
import VideoSuggestion from "./VideoSuggestion";
import {filterVideoList} from "../../../../common/video/VideoActions";
import PuiTypography from "../../../../components/elements/PuiTypography";
import useResponsive from "../../../../common/useResponsive";

const MAX_SUGGESTION_COUNT = 3;

interface VideoSuggestionsPanelProps {
    videoId: number;
}

function VideoSuggestionsPanel({videoId}: VideoSuggestionsPanelProps) {
    const { isMobile } = useResponsive();

    const {userInfo} = useSelector((state: AppState) => ({
        userInfo: state.user.userInfo
   }));

    const {list, videos} = useSelector((({video}: AppState) => video));
    const otherVideoIds = list.filter(id => id !== videoId);

    const dispatch = useDispatch();
    const [hasTriedLoadingMore, setHasTriedLoadingMore] = useState<boolean>(false);

    useEffect(() => {
        let videoFilter = {
            id:[], professional:[],program:[],project:[],tag:[]
       };
        if (!hasTriedLoadingMore && list.length === 1) {
            // 全Videoを取得
            if(userInfo) dispatch(filterVideoList(userInfo.id, videoFilter));
            setHasTriedLoadingMore(true);
       }
   }, [dispatch, hasTriedLoadingMore, list, userInfo]);

    return (
        <div className={styles.root}>
            <div className={styles.title}>
                <PuiTypography bold={true} size={isMobile ? 16: 20}>New videos</PuiTypography>
            </div>

            <div className={styles.list}>
                {otherVideoIds.slice(0, MAX_SUGGESTION_COUNT).map((id) => (
                    <VideoSuggestion key={id} video={videos[id]}/>
                ))}
            </div>
        </div>
    );
}

export default memo(VideoSuggestionsPanel);
